// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type GetDepartmentQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type GetDepartmentQuery = { __typename?: 'Query' } & {
  department: Types.Maybe<
    { __typename?: 'Department' } & Pick<Types.Department, 'id' | 'name'> & {
        definitions: Array<{ __typename?: 'DefinitionItem' } & Pick<Types.DefinitionItem, 'languageCode' | 'content'>>;
      }
  >;
};

export const GetDepartmentDocument = /*#__PURE__*/ gql`
    query getDepartment($id: ID!) {
  department(id: $id) {
    id
    name
    definitions {
      languageCode
      content
    }
  }
}
    `;

/**
 * __useGetDepartmentQuery__
 *
 * To run a query within a React component, call `useGetDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepartmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDepartmentQuery(
  baseOptions: Apollo.QueryHookOptions<GetDepartmentQuery, GetDepartmentQueryVariables> &
    ({ variables: GetDepartmentQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDepartmentQuery, GetDepartmentQueryVariables>(GetDepartmentDocument, options);
}
export function useGetDepartmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDepartmentQuery, GetDepartmentQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDepartmentQuery, GetDepartmentQueryVariables>(GetDepartmentDocument, options);
}
// @ts-expect-error
export function useGetDepartmentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetDepartmentQuery, GetDepartmentQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetDepartmentQuery, GetDepartmentQueryVariables>;
export function useGetDepartmentSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDepartmentQuery, GetDepartmentQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetDepartmentQuery | undefined, GetDepartmentQueryVariables>;
export function useGetDepartmentSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDepartmentQuery, GetDepartmentQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetDepartmentQuery, GetDepartmentQueryVariables>(GetDepartmentDocument, options);
}
export type GetDepartmentQueryHookResult = ReturnType<typeof useGetDepartmentQuery>;
export type GetDepartmentLazyQueryHookResult = ReturnType<typeof useGetDepartmentLazyQuery>;
export type GetDepartmentSuspenseQueryHookResult = ReturnType<typeof useGetDepartmentSuspenseQuery>;
